const {
  getRequest,
  postRequest,
  getDetailRequest,
  patchRequest,
  deleteRequest,
} = require("./axiosRequest");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/patient`;

export const getPatient = (param) => getRequest(url, param);
export const deletePatient = (body) => deleteRequest(url, body);
export const getPatientDetail = (param) => getDetailRequest(url, param);
export const postPatient = (body) => postRequest(url, body);
export const patchPatient = (body) => patchRequest(url, body);
export const getPatientCount = (param) => getRequest(`${url}/count`, param);
